import { render } from "./EventInvitations.vue?vue&type=template&id=15b34357"
import script from "./EventInvitations.vue?vue&type=script&lang=js"
export * from "./EventInvitations.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__